// extracted by mini-css-extract-plugin
module.exports = {"gridItem":"gridItem-module--gridItem--1q1lX","gridHeader":"gridItem-module--gridHeader--3DHqD","gif":"gridItem-module--gif--3I9iF"};